<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['view_pm'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="my-2">
                <div class="row">
                  <b-form-group class="col-md-3" label="Term">
                    <v-select
                      :options="schoolterms"
                      placeholder="Select Term"
                      v-model="schoolterm"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-2" label="Year">
                    <v-select
                      :options="years"
                      placeholder="Select Year"
                      v-model="year"
                    ></v-select>
                  </b-form-group>
                  <div class="col-md-2 mt-md-4 mt-2 p-lg-0">
                    <b-button variant="primary" @click="FilterData()"
                      ><i class="mdi mdi-account-search"></i> Filter</b-button
                    >
                  </div>

                  <div class="d-flex justify-content-end gap-2">
                    <div>
                      <router-link to="/pocketmoney"
                        ><b-button size="sm" variant="primary"
                          ><i class="mdi mdi-plus"></i> Add Pocket
                          Money</b-button
                        ></router-link
                      >
                    </div>
                    <div>
                      <router-link to="/savings"
                        ><b-button size="sm" variant="info"
                          ><i class="mdi mdi-plus"></i> Make a saving</b-button
                        ></router-link
                      >
                    </div>
                    <div>
                      <router-link to="/withdraws"
                        ><b-button size="sm" variant="success"
                          ><i class="mdi mdi-plus"></i> Make a
                          withdraw</b-button
                        ></router-link
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Found</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(student_id)="data">
                    <b class="text-danger">{{
                      data.item.student.student_id
                    }}</b>
                    <br /><small></small>
                  </template>
                  <template #cell(student)="data">
                    {{ data.item.student.first_name }}
                    {{ data.item.student.last_name }}<br /><small
                      style="color:red;"
                    >
                    </small>
                  </template>
                  <template #cell(pocketmoney)="data">
                    {{ commas(data.item.pocketmoney) }}
                  </template>
                  <template #cell(saving)="data">
                    {{ commas(data.item.saving) }}
                  </template>
                  <template #cell(spent)="data">
                    {{ commas(data.item.spent) }}
                  </template>
                  <template #cell(withdraw)="data">
                    {{ commas(data.item.withdraw) }}
                  </template>
                  <template #cell(balance)="data">
                    {{ commas(data.item.balance) }}
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
//import Multiselect from "vue-multiselect";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  schooltermComputed,
  schooltermMethods,
  studentComputed,
  studentMethods,
} from "@/state/helpers";
import Layout from "../../layouts/main";

export default {
  page: {
    title: " Pocket Money Balances",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    // Multiselect,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Pocket Money Balances",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Pocket Money Balances", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "student_id", label: "Student ID", visible: true },
        { key: "student", label: "Name", visible: true },
        { key: "pocketmoney", label: "Pocket Money", visible: true },
        { key: "saving", label: "Savings ", visible: true },
        { key: "withdraw", label: "Withdraws ", visible: true },
        { key: "spent", label: "Spent Amount", visible: true },
        { key: "balance", label: "Balances", visible: true },
      ],
      id: "",
      student_id: "",
      student: "",
      schoolterm: "",
      saving: "",
      year: "",
      pocketmoney: "",
      spent: "",
      balance: "",
      pmbalances: [],
      stream: "",
      class: "",
      name: "",
    };
  },
  computed: {
    ...studentComputed,
    ...schooltermComputed,
    List() {
      return this.pmbalances.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.pmbalances.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.pmbalances.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  mounted() {
    this.fetchSchoolTerms();
    this.fetchStudents();
    this.balances();
    this.TotalRows = this.pmbalances.length;
    this.isBusy = false;
  },
  methods: {
    ...studentMethods,
    ...schooltermMethods,
    customLabel(student) {
      return `${student.student.first_name} ${student.student.last_name} ${student.class.name} ${student.stream.name}`;
    },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    commas(x) {
      if (x == null || x == undefined) return "0";
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async balances() {
      let url = `/pocketmoneybalances`;
      await axios.get(url).then((response) => {
        this.pmbalances = response.data.pmbalances;
      });
    },
  },
};
</script>
